// src/context/NavbarContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const NavbarContext = createContext();

export const NavbarProvider = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    // Auto-collapse sur mobile au chargement
    if (typeof window !== 'undefined' && window.innerWidth < 1024) {
      return true;
    }
    // Récupérer l'état depuis localStorage si disponible pour desktop
    const saved = localStorage.getItem('navbar-collapsed');
    return saved ? JSON.parse(saved) : false;
  });

  // Gérer le responsive automatiquement
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        // Auto-collapse sur mobile/tablet
        setIsCollapsed(true);
      } else {
        // Restaurer l'état sauvegardé sur desktop
        const saved = localStorage.getItem('navbar-collapsed');
        setIsCollapsed(saved ? JSON.parse(saved) : false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Sauvegarder l'état dans localStorage quand il change (seulement sur desktop)
  useEffect(() => {
    if (window.innerWidth >= 1024) {
      localStorage.setItem('navbar-collapsed', JSON.stringify(isCollapsed));
    }
  }, [isCollapsed]);

  const toggleCollapse = () => {
    setIsCollapsed(prev => !prev);
  };

  // Constantes pour les largeurs
  const NAVBAR_WIDTH_EXPANDED = 256; // 64 * 4 = 256px (w-64)
  const NAVBAR_WIDTH_COLLAPSED = 64;  // 16 * 4 = 64px (w-16)

  const value = {
    isCollapsed,
    setIsCollapsed,
    toggleCollapse,
    navbarWidth: isCollapsed ? NAVBAR_WIDTH_COLLAPSED : NAVBAR_WIDTH_EXPANDED
  };

  return (
    <NavbarContext.Provider value={value}>
      {children}
    </NavbarContext.Provider>
  );
};

export const useNavbar = () => {
  const context = useContext(NavbarContext);
  if (!context) {
    throw new Error('useNavbar must be used within a NavbarProvider');
  }
  return context;
};